module.exports = __webpack_public_path__ + "static/media/netstorage/fonts/mako_bold.woff2";